import { getSession, refreshSession } from './cloud';
import { operationJournal } from './operation-journal';
export interface LiveRecord { id: string; owner_id: string; kind: string; data: Record<string, any>; updated_at: string }
export class LiveOperationError extends Error {
  constructor(message: string, readonly resultStatus: string) { super(message); }
}
export async function liveSession() {
  let session=getSession(); if(!session) throw new Error('Private cloud workspace에서 로그인해 주세요.');
  const owner=session.user.id;
  if(session.expires_at<=Date.now()/1000+30) session=await refreshSession();
  if(session.user.id!==owner) throw new Error('계정이 바뀌었습니다. 다시 검토해 주세요.'); return session;
}
export async function liveRequest(endpoint: string, body?: Record<string, any>, options: { blob?: Blob; name?: string; binary?: boolean } = {}): Promise<any> {
  if(!/^\/api\/ops\/[a-z0-9/?=&%_-]+$/i.test(endpoint) || endpoint.includes('..')) throw new Error('Invalid endpoint');
  const session=await liveSession(); const mutation=body!==undefined || !!options.blob;
  const headers: Record<string,string>={authorization:`Bearer ${session.access_token}`};
  if(body) headers['content-type']='application/json';
  if(options.blob) { headers['content-type']=options.blob.type; headers['x-audio-name']=encodeURIComponent(options.name||'Recording'); }
  let response: Response;
  try { response=await fetch(endpoint,{method:mutation?'POST':'GET',headers,body:options.blob || (body?JSON.stringify(body):undefined),cache:'no-store',redirect:'error',signal:AbortSignal.timeout(45000)}); }
  catch { throw new Error(mutation ? `결과를 확인하지 못했습니다. 작업 기록을 확인하기 전 다시 실행하지 마세요. 작업 ID: ${body?.operationId||endpoint.split('/').at(-1)}` : '서버 연결을 확인해 주세요.'); }
  if(getSession()?.user.id!==session.user.id) throw new Error('계정이 바뀌었습니다. 이전 계정의 작업 기록에서 결과를 확인해 주세요.');
  if(options.binary && response.ok) return response.blob();
  const result=await response.json().catch(()=>null);
  if(!response.ok) throw new Error(result?.error?.message || `서버 오류 (${response.status})`);
  if(!result) throw new Error('응답을 확인할 수 없습니다. 작업 기록을 확인해 주세요.');
  if(['failed','uncertain','processing'].includes(result.status)) throw new LiveOperationError(`${result.message || result.status} · 작업 ID ${result.operationId || body?.operationId}`,result.status);
  return result;
}
export async function liveAction(endpoint:string, input:Record<string,any>={}) {
  const readOnly = ['discovery','phone-result','inbox-sync','crm-import'].includes(endpoint) || (['calendar','crm-deals'].includes(endpoint) && input.action === 'list');
  if (readOnly || input.operationId) return liveRequest('/api/ops/'+endpoint,{...input,operationId:input.operationId||crypto.randomUUID()});
  const session = await liveSession();
  const journal = await operationJournal(sessionStorage,session.user.id,endpoint,input);
  try {
    const result = await liveRequest('/api/ops/'+endpoint,{...input,operationId:journal.id});
    journal.complete();
    return result;
  } catch (error) {
    // A definitive failure may be reviewed and retried after fixing configuration.
    // Lost responses and uncertain/processing results must keep the original ID.
    if (error instanceof LiveOperationError && error.resultStatus === 'failed') journal.complete();
    throw error;
  }
}
